import type { DemoSet } from '../../types'
import { cascade3plDashboards } from './dashboards'
import { cascade3plInsight } from './insight'
import { cascadeMockJobDetail, cascadeMockJobs } from './mockJobs'
import { bulkLabelAgent } from './scripts/bulkLabelAgent'
import { carrierClaims } from './scripts/carrierClaims'
import { customerPnlForecast } from './scripts/customerPnlForecast'
import { laborForecast } from './scripts/laborForecast'
import { postShipmentSupport } from './scripts/postShipmentSupport'

/**
 * Cascade 3PL — canonical mid-market 3PL demo persona. ~$165M annual revenue,
 * 4 fulfillment centers (Indianapolis HQ, Atlanta, Reno, Charlotte), ~280 FTE,
 * 68 DTC brand customers. Stack: ShipHero Enterprise WMS, NetSuite ERP,
 * Google Workspace, Slack, multiple carrier integrations (UPS, FedEx, USPS,
 * OnTrac), Stripe.
 *
 * Top customers: Northwind Apparel ($22M/yr, largest by revenue), Briar Coffee Roasters,
 * Trailmix Provisions, OakHill Skincare, Altitude Supplements, Halcyon Pet,
 * Fernweh Outdoors, Lumen Candles + 60 lower-volume.
 *
 * Persona Jordan Castillo — Chief Operating Officer.
 *
 * Persona/data are swappable for other 3PL prospects — see
 * `docs/demos/cascade-3pl.md`. Five-demo set: Customer P&L Forecast (1),
 * Bulk Label Agent (2), Post-Shipment Support (3), Carrier Claims (4),
 * Labor Forecast (5).
 */
export const cascade3plSet: DemoSet = {
  id: 'cascade-3pl',
  name: 'Cascade 3PL',
  description:
    'Canonical mid-market 3PL persona. ~$165M annual revenue, 4 fulfillment centers (Indianapolis HQ, Atlanta, Reno, Charlotte), ~280 FTE, 68 DTC brand customers. ShipHero Enterprise + NetSuite + Google Workspace + Slack stack. Five-demo set: Customer P&L Forecast, Bulk Label Agent, Post-Shipment Support, Carrier Claims, Labor Forecast.',
  scripts: [
    bulkLabelAgent,
    postShipmentSupport,
    carrierClaims,
    customerPnlForecast,
    laborForecast,
  ],
  insight: cascade3plInsight,
  userPersona: {
    firstName: 'Jordan',
    lastName: 'Castillo',
  },
  mockJobs: cascadeMockJobs,
  mockJobDetail: cascadeMockJobDetail,
  dashboards: cascade3plDashboards,
}
